module.exports = __webpack_public_path__ + "static/maya-294448d2dfa88cd95b17fa33658a433f.png";